import { useMemo, useState } from "react";
import ArticleListItem from "@/components/base/ArticleListItem";
import Pagination from "@/components/base/Pagination";
import { getLatestArticles, paginate } from "@/lib/news";

const PAGE_SIZE = 15;

export default function LatestSection() {
  const [page, setPage] = useState(1);
  const all = useMemo(() => getLatestArticles(), []);
  const { items, totalPages, currentPage, total } = paginate(all, page, PAGE_SIZE);

  const handleChange = (next: number) => {
    setPage(next);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section>
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按发布时间倒序排列，共 {total} 条黑料信息。
          </p>
        </div>
        <span className="hidden items-center gap-1 text-xs font-label text-foreground-400 sm:flex">
          <i className="ri-sort-desc" />
          最新优先
        </span>
      </div>

      <div className="space-y-3">
        {items.map((article, index) => (
          <ArticleListItem
            key={article.id}
            article={article}
            order={index}
          />
        ))}
      </div>

      <div className="mt-8">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={handleChange}
        />
      </div>
    </section>
  );
}